import Navbar from "../components/common/Navbar";
import EventsHero from "../components/eventsExperiences/EventsHero";
import EventsTypes from "../components/eventsExperiences/EventsTypes";
import EventsServices from "../components/eventsExperiences/EventsServices";
// import EventsShowcase from "../components/eventsExperiences/EventsShowcase";
import EventsWhy from "../components/eventsExperiences/EventsWhy";
import EventsProcess from "../components/eventsExperiences/EventsProcess";
import EventsCta from "../components/eventsExperiences/EventsCta";
// Scroll position on arrival is handled by MainLayout.
import "../styles/eventsExperiences.css";

const EventsExperiencesPage = () => (
  <div className="ee ee-events">
    <Navbar />
    <EventsHero />
    <EventsTypes />
    <EventsServices />
    {/* <EventsShowcase /> */}
    <EventsWhy />
    <EventsProcess />
    <EventsCta />
  </div>
);

export default EventsExperiencesPage;
